import { render } from "./health-check.vue?vue&type=template&id=8ecf5382&ts=true"
import script from "./health-check.vue?vue&type=script&lang=ts"
export * from "./health-check.vue?vue&type=script&lang=ts"

import "./health-check.vue?vue&type=style&index=0&id=8ecf5382&lang=scss"

import exportComponent from "/Users/brian/VIS Solutions/aeon-boxed-middleware-spa/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__